import {
  exportFileCommon
} from "../http/dictionary"

/**
 * url:导出的api地址
 * prams:导出传入的参数
 * finallyCb:导出接口调用完成的回调函数
 */
export default (url, params, finallyCb) => {
  exportFileCommon(url, params).then(res => {
    let {
      data,
      headers = {}
    } = res
    let type = headers['content-type'] ? headers['content-type'] : 'application/vnd.ms-excel'
    let filename = headers['content-disposition'] ? decodeURI(headers['content-disposition'].split('filename=')[1]) : new Date().toLocaleDateString()
    const blobFile = new Blob([data], {
      type
    });
    if (window.navigator.msSaveOrOpenBlob) { //兼容性处理
      navigator.msSaveBlob(blobFile, filename);
    } else {
      let a = document.createElement('a');
      a.href = URL.createObjectURL(blobFile);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }).finally(_ => {
    if (finallyCb && typeof finallyCb === 'function') finallyCb()
  })
}
